import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import Header from './components/Header3';
import Footer from './components/Footer3';

const Login3 = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ email: '', password: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => { e.preventDefault(); navigate('/template3'); };

    const inputBaseClass = "w-full px-4 py-3.5 bg-[#FFFFFF] border border-[#E8E0D8] text-[#1A1A1A] text-sm outline-none transition-colors duration-300 focus:border-[#722F37] placeholder-[#9CA3AF]";

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Lato:wght@300;400;700&display=swap');`}</style>
            <div style={{ fontFamily: "'Lato', sans-serif" }} className="min-h-screen bg-[#FFFDF7]">
                <Header />
                <main className="pt-20 min-h-screen flex">
                    {/* Left Side - Hero Image (Desktop Only) */}
                    <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
                        <img src="https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=1200" alt="Luxury fashion" className="absolute inset-0 w-full h-full object-cover" />
                        <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(114,47,55,0.3) 0%, rgba(114,47,55,0.6) 50%, rgba(255,253,247,1) 100%)' }} />
                        <div className="relative z-10 flex flex-col justify-center items-start p-16 max-w-lg">
                            <div className="w-12 h-px bg-[#B8860B] mb-6" />
                            <h2 style={{ fontFamily: "'Playfair Display', serif" }} className="text-4xl xl:text-5xl font-bold text-[#FFFFFF] leading-tight mb-4">
                                Royal Collections Await
                            </h2>
                            <p className="text-[#FFFFFF]/80 text-base leading-relaxed">
                                Step into a world of royal elegance and timeless Indian couture crafted for the modern connoisseur.
                            </p>
                        </div>
                    </div>

                    {/* Right Side - Login Form */}
                    <div className="flex-1 flex items-center justify-center px-6 py-12 lg:py-0">
                        <div className="w-full max-w-md">
                            <div className="text-center mb-10">
                                <h1 onClick={() => navigate('/template3')} style={{ fontFamily: "'Playfair Display', serif" }} className="text-3xl font-bold text-[#722F37] cursor-pointer tracking-[3px] mb-3">
                                    VASTRA
                                </h1>
                                <h2 style={{ fontFamily: "'Playfair Display', serif" }} className="text-2xl lg:text-3xl font-bold text-[#722F37] tracking-wide">
                                    Welcome Back
                                </h2>
                                <p className="text-[#6B7280] text-sm mt-2">Sign in to access your account and exclusive collections</p>
                            </div>

                            <form onSubmit={handleSubmit} className="space-y-5">
                                <div>
                                    <label className="block text-[#1A1A1A] text-sm font-bold mb-2">Email</label>
                                    <div className="relative">
                                        <Mail size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#6B7280]" />
                                        <input type="email" name="email" value={formData.email} onChange={handleInputChange} required placeholder="you@example.com" className={`${inputBaseClass} pl-12`} />
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-[#1A1A1A] text-sm font-bold mb-2">Password</label>
                                    <div className="relative">
                                        <Lock size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#6B7280]" />
                                        <input type={showPassword ? 'text' : 'password'} name="password" value={formData.password} onChange={handleInputChange} required placeholder="Enter your password" className={`${inputBaseClass} pl-12 pr-12`} />
                                        <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-[#6B7280]">
                                            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                        </button>
                                    </div>
                                </div>
                                <div className="flex justify-end">
                                    <button type="button" className="text-sm" style={{ color: '#722F37' }}>Forgot Password?</button>
                                </div>
                                <button type="submit" className="w-full py-4 text-sm font-bold tracking-[0.15em] uppercase transition-all duration-300" style={{ backgroundColor: '#722F37', color: '#FFFFFF' }} onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#5A1F2A'; }} onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#722F37'; }}>
                                    Sign In
                                </button>
                            </form>

                            <p className="text-center mt-8 text-sm" style={{ color: '#6B7280' }}>
                                Don't have an account?{' '}
                                <button onClick={() => navigate('/template3/signup')} className="font-bold" style={{ color: '#722F37' }}>Create Account</button>
                            </p>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Login3;
